class ActivityTracker {
  constructor(options = {}) {
    this.heartbeatInterval = options.heartbeatInterval || 1000 * 60 * 5; // 5 minutes
    this.warningBuffer = options.warningBuffer || 60;
    this.heartbeatEndpoint = '/api/v1/sessions/heartbeat';
    this.lastActivityTime = Date.now()
    this.heartbeatTimer = null;
    this.isActive = true;
    this.pageContext = options.pageContext || 'general';
    this.pendingHeartbeat = null;

    this.init();
  }

  init() {
    this.bindActivityEvents();
    this.startAdaptiveHeartbeat();
  }

  bindActivityEvents() {
    $(document).on('click keypress', (e) => {
      this.recordActivity(e);
    });
  }

  recordActivity(event = null) {
    if (!this.isActive) return;

    this.lastActivityTime = Date.now();

    if (typeof window.tokenExpiresIn !== 'undefined' && window.tokenExpiresIn < this.warningBuffer) {
      this.sendHeartbeat('activity_near_expiration');
      
    }
  }

  startAdaptiveHeartbeat() {
    const schedule = () => {
      clearTimeout(this.heartbeatTimer);
      const leftMs   = (window.tokenExpiresIn ?? 0) * 1_000;
      const nextMs   = Math.max(10_000,
                      Math.min(this.heartbeatInterval,
                                leftMs / 2));

      this.heartbeatTimer = setTimeout(async () => {
        if (this.isActive && window.tokenExpiresIn > this.warningBuffer) await this.sendHeartbeat('adaptive');
        schedule();
        }, nextMs);
    };

    schedule(); 
  }

  async sendHeartbeat(trigger = 'manual') {
    if (this.pendingHeartbeat) {
      return;
    }

    const metaElement = document.querySelector('meta[name="csrf-token"]');
    const xcsrfToken = metaElement ? metaElement.content : '';
    const secondsSinceActivity = Math.floor((Date.now() - this.lastActivityTime) / 1000);

    const headers = {
      'X-CSRF-Token': xcsrfToken,
      'Content-Type': 'application/json'
    };

    const body = JSON.stringify({
      active_ago: secondsSinceActivity,
      page_context: this.pageContext,
      trigger: trigger
    });

    try {
      this.pendingHeartbeat = fetch(this.heartbeatEndpoint, {
        method: 'POST',
        headers,
        body
      });
      const response = await this.pendingHeartbeat;

      if (response.ok) {
        const data = await response.json();
        this.updateSessionTimerFromServerResponse(data, trigger);
      } else {
        console.error(`[ActivityTracker] Heartbeat failed (${trigger}):`, response.status, response.statusText);
        this.handleHeartbeatError({ status: response.status }, trigger);
      }
    } catch (error) {
      console.error(`[ActivityTracker] Heartbeat request failed (${trigger}):`, error);
      this.handleHeartbeatError({ status: 500 }, trigger);
    } finally {
      this.pendingHeartbeat = null;
    }
  }

  updateSessionTimerFromServerResponse(response, trigger) {
    if (typeof window.tokenExpiresIn !== 'undefined') {
      const expiresAtDate = new Date(response.expires_at);
      const serverTimeDate = new Date(response.server_time);
      const remainingSeconds = Math.floor((expiresAtDate - serverTimeDate) / 1000);
      
      window.tokenExpiresIn = Math.max(0, remainingSeconds);
    }
  }

  handleHeartbeatError(xhr, trigger) {
    console.error(`[ActivityTracker] Heartbeat failed (${trigger}):`, xhr.status, xhr.statusText);
    
    if (xhr.status === 401) {
      window.location = '/timeout?logout=true'
    } else if (xhr.status >= 500) {
      console.warn('[ActivityTracker] Server error, will retry on next heartbeat');
    }
  }

  getStatus() {
    const secondsSinceActivity = Math.floor((Date.now() - this.lastActivityTime) / 1000);
    const sessionTimeRemaining = window.tokenExpiresIn || 0;

    return {
      isActive: this.isActive,
      lastActivityTime: this.lastActivityTime,
      secondsSinceActivity: secondsSinceActivity,
      sessionTimeRemaining: sessionTimeRemaining,
      warningBuffer: this.warningBuffer,
      pageContext: this.pageContext
    };
  }
}

window.ActivityTracker = ActivityTracker;
